module.exports = __webpack_public_path__ + "img/ico-rect-green.71ceb696.svg";